module.exports = __webpack_public_path__ + "img/login_work_time.be3a343e.svg";